export enum FlightScaleTableSize {
  RG = 'rg',
  MD = 'md',
  SM = 'sm',
  Minor = 'minor',
}

export interface FlightScaleTableBaggage {
  CheckedBaggage: boolean;
  CabinbBaggage: boolean;
  PersonalItem: boolean;
}

export interface FlightScaleTableLugaggeHoverEvent {
  enter: boolean;
  leave: boolean;
}

export type FlightScaleTablePointTime = `${number}:${number}` | null | undefined;
export type FlightScaleTableDaysDifference = `+${number}` | '' | null | undefined;

